/* eslint-disable */

export class IDateCalculator {
  addDays(date: Date, days: number) {
    throw new Error("Not implemented")
  }

  addSeconds(date: Date, seconds: number) {
    throw new Error("Not implemented")
  }

  addMinutes(date: Date, minutes: number) {
    throw new Error("Not implemented")
  }

  differenceInDays(date1: Date, date2: Date) {
    throw new Error("Not implemented")
  }

  differenceInSeconds(date1: Date, date2: Date) {
    throw new Error("Not implemented")
  }

  differenceInMilliseconds(date1: Date, date2: Date) {
    throw new Error("Not implemented")
  }
  secondsUntilNextEpoch(date: Date) {
    throw new Error("Not implemented")
  }
}

export class IDateFormatter {
  format(date: number | Date, formatString: string) {
    throw new Error("Not implemented")
  }

  formatDistanceToNow(date: Date, options: { addSuffix: true }) {
    throw new Error("Not implemented")
  }

  formatCountdownTimer(seconds: number) {
    throw new Error("Not implemented")
  }

  currentEpochNumber(date: any) {
    throw new Error("Not implemented")
  }
}

export class IDateParser {
  parse(dateString: string, formatString: string, backupDate: Date) {
    throw new Error("Not implemented")
  }

  fromUnixTime(unixTimestamp: number) {
    throw new Error("Not implemented")
  }

  getUnixTime(date: Date) {
    throw new Error("Not implemented")
  }
}

export default {
  IDateCalculator,
  IDateFormatter,
  IDateParser,
}
